import { render, staticRenderFns } from "./systemHealth_TRA.vue?vue&type=template&id=2e6747e1&"
import script from "./systemHealth_TRA.vue?vue&type=script&lang=js&"
export * from "./systemHealth_TRA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports